import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton, B1 } from '../../StyledComponents';
import { navigate, StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import avd from '../../../assets/v2/avd.svg';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOneTitle = styled(Title)`
  color: #a78eff;
  margin-top: 5rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;

const Section = styled(SectionParent)`
  display: grid;
  padding-top: 5rem !important;
  position: relative;
  z-index: 0;
  background: radial-gradient(circle at 49% 28%, rgb(51, 51, 51), rgb(0, 0, 0));

  padding-bottom: 0rem !important;
  display: grid;
`;
const HeroImgContainerLeft = styled(LazyLoadImage)`
  width: 100%;
  justify-self: center;
  @media (max-width: 520px) {
    display: none;
  }
`;
const HeroImgContainerMobile = styled(GatsbyImage)`
  width: 100%;
  justify-self: center;
  @media (min-width: 520px) {
    display: none;
  }
`;
const HeroImgContainer = styled.div`
  /* height: 19.7rem; */
  position: relative;
  /* display: grid; */
  justify-content: center;
  padding: 2rem 0rem;
  margin-top: 3rem;
`;

const SolutionsContent = styled.div`
  grid-column: span 7;
  display: grid;
  /* padding-bottom: 4rem; */
  @media (max-width: 768px) {
    grid-column: span 14;
    padding-bottom: 2rem;
    padding-left: 0;
  }
  @media (max-width: 520px) {
    grid-column: span 14;
    padding-left: 0;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: flex;
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;

const EsperManagePage = styled.div`
  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`;

const SecondSectionContent = styled(B1)`
  text-align: center;
  color: #dcdde1;
  margin: auto;
  max-width: 64rem;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    padding-bottom: 1rem;
  }
`;
class AvdSectionOne extends React.PureComponent<any, any> {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query DataQuery {
            avdDesktop: file(relativePath: { eq: "v2/png/AvdHero.png" }) {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1800) {
                  aspectRatio
                  src
                  sizes
                  srcWebp
                }
              }
            }

            avdMobile: file(relativePath: { eq: "v2/png/AvdHeroMobile.png" }) {
              childImageSharp {
                fluid(maxWidth: 700, quality: 100) {
                  aspectRatio
                  src
                  sizes
                  srcWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <div style={{ position: 'relative' }}>
            <Section>
              <SolutionsContent>
                <EsperManagePage>
                  <SectionOneTitle
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    Build Custom Android Virtual Devices
                  </SectionOneTitle>
                  <SecondSectionContent>
                    Enterprise Android devices come in various form factors, OS
                    versions and may have a host of unique peripherals. Esper’s
                    Android Virtual Device is an emulator which helps Android
                    developers to test their applications by defining the
                    characteristics of your Android phone, tablet, or other
                    device. It simulates the real device capabilities. You can
                    create as many Virtual Devices as you need, based on the
                    type of device you want to test and the load you need to
                    create on your backend.
                  </SecondSectionContent>
                  <HeroImgContainer>
                    <HeroImgContainerLeft
                      alt="Esper Avd"
                      loading="lazy"
                      src={avd}
                    />
                    <HeroImgContainerMobile
                      alt="Esper Avd"
                      loading="lazy"
                      fluid={data.avdMobile.childImageSharp.fluid}
                    />
                  </HeroImgContainer>
                  {/* <EsperManageSubHeading>ESPER MANAGE</EsperManageSubHeading> */}

                  <BlueButtonWrapper>
                    <BlueButton
                      id="avd__build_virtual_devices"
                      onClick={() => navigate('/signup')}
                      style={{
                        marginLeft: '0',
                        backgroundColor: '#725cbd',
                        textTransform: 'none',
                      }}
                    >
                      Build virtual devices
                    </BlueButton>
                  </BlueButtonWrapper>
                </EsperManagePage>
              </SolutionsContent>
            </Section>
          </div>
        )}
      />
    );
  }
}
export default AvdSectionOne;
